'use client'

// The camera across the street from the job centre while it is open (components/ui/JobCentreHud.jsx), the vending
// machine's close view again (VendingCam): it eases there from wherever the walker left it and holds; the walker stands
// down while it is mounted (mainScene's fpEnabled) and picks up where it was when it closes.

import { useMemo, useRef } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import * as THREE from 'three/webgpu'
import { jobCentreShot, jobCentreSpot } from '../../../lib/world/jobCentre'

const SPRING = 4

export function JobCentreCam() {
  const { camera } = useThree()
  const shot = useMemo(() => jobCentreShot(jobCentreSpot()), [])
  const look = useRef(null)
  const eye = useMemo(() => (shot ? new THREE.Vector3(...shot.eye) : null), [shot])
  const target = useMemo(() => (shot ? new THREE.Vector3(...shot.target) : null), [shot])

  useFrame((_, dt) => {
    if (!eye) return
    if (!look.current) {
      look.current = new THREE.Vector3()
      camera.getWorldDirection(look.current)
      look.current.multiplyScalar(4).add(camera.position)
    }
    const k = 1 - Math.exp(-SPRING * Math.min(dt, 0.1))
    camera.position.lerp(eye, k)
    look.current.lerp(target, k)
    camera.lookAt(look.current)
  })
  return null
}
